module.exports = __webpack_public_path__ + "static/media/Reservations_Icon.eb048921.png";